import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";
import moment from "moment";
import { useNavigate } from "react-router-dom";

function Blog() {
    //define state
    const navigate = useNavigate();
    const [blog, setBlog] = useState([]);

    //function "fetchData"
    const fetchData = async () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            // Set token in axios headers
            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = token;
                    return config;
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
            // fetching
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/blog/readBlog`);
            // get response data
            const data = response.data;
            // assign response data to state "Customer"
            setBlog(data);
        } catch (error) {
            console.error("Error fetching data:", error);
            // Handle error, e.g., show a galeri-friendly message
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleDelete = async (id_blog) => {
        Swal.fire({
            title: "Warning",
            text: "Apakah yakin ingin menghapus data ini?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await axios.delete(
                        `${process.env.REACT_APP_API_URL}/blog/deleteBlog/${id_blog}`
                    );
                    fetchData();

                    Swal.fire("Dihapus!", "Data berhasil dihapus.", "success");
                } catch (error) {
                    console.error("Error deleting data:", error);
                    Swal.fire("Error!", "Terjadi kesalahan saat menghapus data.", "error");
                }
            }
        });
    };

    const columns = [
        {
            name: "No",
            selector: (row, index) => index + 1,
            sortable: false,
            width: "70px",
        },
        {
            name: "Title",
            selector: (row) => row.title,
            sortable: true,
            width: "150px",
        },
        {
            name: "Group",
            selector: (row) => row.group_name,
            sortable: true,
        },
        {
            name: "Highlight",
            selector: (row) => (
                <img
                    src={
                        row.foto_main.startsWith("http")
                            ? row.foto_main
                            : `${process.env.REACT_APP_API_URL}/blog/uploads/${row.foto_main}`
                    }
                    alt="galeri"
                    style={{ width: "100px", height: "70px" }}
                />
            ),
            sortable: true,
            width: "150px",
        },
        {
            name: "Detail Highlight",
            selector: (row) => row.detail_foto_main,
            sortable: true,
            width: "200px",
        },
        {
            name: "Tanggal Foto Main",
            selector: (row) => moment(row.tanggal_foto_main).format("YYYY-MM-DD"),
            sortable: true,
        },
        {
            name: "Title Foto 1",
            selector: (row) => row.title_foto_satu,
            sortable: true,
            width: "150px",
        },
        {
            name: "Foto 1",
            selector: (row) => (
                <img
                    src={
                        row.foto_satu.startsWith("http")
                            ? row.foto_satu
                            : `${process.env.REACT_APP_API_URL}/blog/uploads/${row.foto_satu}`
                    }
                    alt="galeri"
                    style={{ width: "100px", height: "70px" }}
                />
            ),
            sortable: true,
            width: "150px",
        },
        {
            name: "Detail Foto 1",
            selector: (row) => row.detail_foto_satu,
            sortable: true,
            width: "200px",
        },
        {
            name: "Tanggal Foto Satu",
            selector: (row) => moment(row.tanggal_foto_satu).format("YYYY-MM-DD"),
            sortable: true,
        },
        {
            name: "Title Foto 2",
            selector: (row) => row.title_foto_dua,
            sortable: true,
            width: "150px",
        },
        {
            name: "Foto 2",
            selector: (row) => (
                <img
                    src={
                        row.foto_dua.startsWith("http")
                            ? row.foto_dua
                            : `${process.env.REACT_APP_API_URL}/blog/uploads/${row.foto_dua}`
                    }
                    alt="galeri"
                    style={{ width: "100px", height: "70px" }}
                />
            ),
            sortable: true,
            width: "150px",
        },
        {
            name: "Detail Foto 2",
            selector: (row) => row.detail_foto_dua,
            sortable: true,
            width: "200px",
        },
        {
            name: "Tanggal Foto Dua",
            selector: (row) => moment(row.tanggal_foto_dua).format("YYYY-MM-DD"),
            sortable: true,
        },
        {
            name: "Title Foto 3",
            selector: (row) => row.title_foto_tiga,
            sortable: true,
            width: "150px",
        },
        {
            name: "Foto 3",
            selector: (row) => (
                <img
                    src={
                        row.foto_tiga.startsWith("http")
                            ? row.foto_tiga
                            : `${process.env.REACT_APP_API_URL}/blog/uploads/${row.foto_tiga}`
                    }
                    alt="galeri"
                    style={{ width: "100px", height: "70px" }}
                />
            ),
            sortable: true,
            width: "150px",
        },
        {
            name: "Detail Foto 3",
            selector: (row) => row.detail_foto_tiga,
            sortable: true,
            width: "200px",
        },
        {
            name: "Tanggal Foto Tiga",
            selector: (row) => moment(row.tanggal_foto_tiga).format("YYYY-MM-DD"),
            sortable: true,
        },
        {
            name: "Aksi",
            cell: (row) => (
                <>
                    <Link to={`/blogEdit/${row.id_blog}`} className="btn btn-warning mr-2">
                        <i className="nav-icon fas fa-edit" />
                    </Link>
                    <button onClick={() => handleDelete(row.id_blog)} className="btn btn-danger">
                        <i className="nav-icon fas fa-trash" />
                    </button>
                </>
            ),
            sortable: false,
        },
    ];

    return (
        <div className="wrapper">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <a href="/#">Administrasi</a>
                                    </li>
                                    <li className="breadcrumb-item active">Blog</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Data Blog</h3>
                                    </div>
                                    <div className="card-body">
                                        <Link to="/blogAdd" className="btn btn-primary">
                                            <i className="nav-icon fas fa-plus mr-2" />
                                            Add Data
                                        </Link>
                                        <DataTable columns={columns} data={blog} pagination />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Blog;
